(async () => {
  const STORAGE_KEYS = {
    hadGuestCart: 'il_had_guest_cart',
    cartRefreshedAfterLogin: 'il_cart_refreshed_after_login',
    lastCustomerTags: 'il_last_customer_tags',
    cartRefreshedAfterTagInit: 'il_cart_refreshed_after_tag_init',
    drawerRecalcLastTs: 'il_drawer_recalc_last_ts'
  };

  const PENDING_CLASS = 'il-cart-recalc-pending';
  const FETCH_TIMEOUT_MS = {
    cartJs: 12000,
    updateJs: 15000
  };

  function setRecalcPending(on) {
    var root = document.documentElement;
    var main = document.getElementById('main');
    if (on) {
      root.classList.add(PENDING_CLASS);
      if (main) main.setAttribute('aria-busy', 'true');
    } else {
      root.classList.remove(PENDING_CLASS);
      if (main) main.removeAttribute('aria-busy');
    }
  }

  function fetchWithTimeout(url, options, timeoutMs) {
    if (typeof AbortSignal !== 'undefined' && AbortSignal.timeout) {
      return fetch(url, {
        ...options,
        signal: AbortSignal.timeout(timeoutMs)
      });
    }
    var ctrl = new AbortController();
    var id = setTimeout(function () {
      ctrl.abort();
    }, timeoutMs);
    return fetch(url, { ...options, signal: ctrl.signal }).finally(function () {
      clearTimeout(id);
    });
  }

  function isCustomerLoggedIn() {
    return document.documentElement.dataset.customerLoggedIn === 'true';
  }

  /**
   * 未ログイン中にカートが変わったことを記録する。
   * ページ未リロードのAjaxカートインだけだと初期 getCart では hadGuestCart が立たず、
   * ログイン直後に自動ディスカウント再計算がスキップされるため。
   */
  function markGuestHadCartFromCart(cart) {
    if (isCustomerLoggedIn()) return;
    const n = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
    if (n > 0) sessionStorage.setItem(STORAGE_KEYS.hadGuestCart, 'true');
  }

  const isLoggedIn = isCustomerLoggedIn();
  const currentCustomerTags = (document.documentElement.dataset.customerTags || '').trim();

  async function getCart() {
    const res = await fetchWithTimeout(
      '/cart.js',
      {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      },
      FETCH_TIMEOUT_MS.cartJs
    );
    if (!res.ok) throw new Error('Failed to fetch cart');
    return await res.json();
  }

  window.addEventListener(
    'cart:updated',
    function () {
      if (isCustomerLoggedIn()) return;
      getCart()
        .then(markGuestHadCartFromCart)
        .catch(function () {});
    },
    true
  );

  document.addEventListener(
    'cart:change',
    function (e) {
      if (isCustomerLoggedIn()) return;
      var c = e.detail && e.detail.cart;
      markGuestHadCartFromCart(c);
    },
    true
  );

  async function touchCartForRecalculation() {
    const res = await fetchWithTimeout(
      '/cart/update.js',
      {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            _customer_login_refresh: String(Date.now())
          }
        })
      },
      FETCH_TIMEOUT_MS.updateJs
    );

    if (!res.ok) throw new Error('Failed to update cart');
    return await res.json();
  }

  function isCartTemplatePage() {
    if (
      window.themeVariables &&
      window.themeVariables.settings &&
      window.themeVariables.settings.pageType === 'cart'
    ) {
      return true;
    }
    var p = window.location.pathname || '';
    return p === '/cart' || p === '/cart/';
  }

  async function refreshPrestigeCartUI() {
    // カートページはフルページ再読込で十分。
    if (isCartTemplatePage()) {
      window.location.reload();
      return;
    }

    // CartDrawer は cart:refresh で section HTML を再取得する。直後の await getCart + cart:change は
    // ネット往復が増えドロワー更新が遅れるため行わない（variant:add 等はテーマが既に cart:change を飛ばす）。
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

    window.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));

    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.show === 'function' && drawer.open) {
      drawer.show();
    }

    if (!drawer) {
      const startedAt = Date.now();
      const obs = new MutationObserver(() => {
        const d = document.querySelector('cart-drawer');
        if (!d) return;
        obs.disconnect();
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      });

      obs.observe(document.body, { childList: true, subtree: true });
      setTimeout(() => {
        try { obs.disconnect(); } catch (e) {}
      }, Math.max(0, 2000 - (Date.now() - startedAt)));
    }
  }

  // Drawer を開いたタイミングでも確実に再計算する（タグ変更が同一ページで反映されないため）
  const DRAWER_RECALC_THROTTLE_MS = 60 * 1000;
  async function recalcForDrawerOpen() {
    if (!isLoggedIn) return;
    if (window.__CART_REFRESH_RUNNING__) return;

    const now = Date.now();
    const lastTs = parseInt(sessionStorage.getItem(STORAGE_KEYS.drawerRecalcLastTs) || '0', 10);
    if (lastTs && now - lastTs < DRAWER_RECALC_THROTTLE_MS) return;
    sessionStorage.setItem(STORAGE_KEYS.drawerRecalcLastTs, String(now));

    window.__CART_REFRESH_RUNNING__ = true;
    try {
      // 先にドロワー HTML を更新してから属性タッチ（体感を優先。割引は続くリクエストで追随）
      await refreshPrestigeCartUI();
      touchCartForRecalculation()
        .then(function () {
          return refreshPrestigeCartUI();
        })
        .catch(function () {});
    } finally {
      window.__CART_REFRESH_RUNNING__ = false;
    }
  }

  function wireDrawerOpenListener(drawerEl) {
    if (!drawerEl) return;
    // open 属性の変更をトリガーにする（cart-drawer は Drawer コンポーネント）
    var mo = new MutationObserver(function () {
      if (drawerEl.open || drawerEl.hasAttribute('open')) {
        recalcForDrawerOpen();
      }
    });
    mo.observe(drawerEl, { attributes: true, attributeFilter: ['open'] });

    // 既に開いている場合
    if (drawerEl.open || drawerEl.hasAttribute('open')) {
      recalcForDrawerOpen();
    }
  }

  // 既存の cart-drawer が無い場合にも対応して DOM 投入後に配線
  (function setupDrawerListener() {
    var existing = document.querySelector('cart-drawer');
    if (existing) {
      wireDrawerOpenListener(existing);
      return;
    }

    var rootMo = new MutationObserver(function () {
      var d = document.querySelector('cart-drawer');
      if (!d) return;
      rootMo.disconnect();
      wireDrawerOpenListener(d);
    });

    rootMo.observe(document.body, { childList: true, subtree: true });
  })();

  try {
    const cart = await getCart();
    const hasItems = cart.item_count > 0;

    if (!isLoggedIn) {
      if (hasItems) {
        sessionStorage.setItem(STORAGE_KEYS.hadGuestCart, 'true');
      } else {
        sessionStorage.removeItem(STORAGE_KEYS.hadGuestCart);
      }
      sessionStorage.removeItem(STORAGE_KEYS.cartRefreshedAfterLogin);
      sessionStorage.removeItem(STORAGE_KEYS.lastCustomerTags);
      sessionStorage.removeItem(STORAGE_KEYS.cartRefreshedAfterTagInit);
      return;
    }

    const hadGuestCart = sessionStorage.getItem(STORAGE_KEYS.hadGuestCart) === 'true';
    const alreadyRefreshed =
      sessionStorage.getItem(STORAGE_KEYS.cartRefreshedAfterLogin) === 'true';

    const prevCustomerTags = sessionStorage.getItem(STORAGE_KEYS.lastCustomerTags);
    const tagsKnown = prevCustomerTags !== null;
    const tagsChanged = tagsKnown && prevCustomerTags !== currentCustomerTags;

    const shouldRefreshForLogin = hadGuestCart && hasItems && !alreadyRefreshed;
    const shouldRefreshForTagChange = tagsChanged && hasItems;
    // タグのベースラインが sessionStorage に無い場合でも、
    // 「今のタグ」前提で一度 cart を再計算しておく（初回訪問で取りこぼすのを防ぐ）
    const shouldRefreshForTagInit = !tagsKnown && hasItems && sessionStorage.getItem(STORAGE_KEYS.cartRefreshedAfterTagInit) !== 'true';

    if (!shouldRefreshForLogin && !shouldRefreshForTagChange && !shouldRefreshForTagInit) return;

    if (shouldRefreshForLogin) {
      sessionStorage.setItem(STORAGE_KEYS.cartRefreshedAfterLogin, 'true');
    }

    // ベースライン（比較元）を更新
    sessionStorage.setItem(STORAGE_KEYS.lastCustomerTags, currentCustomerTags);

    if (shouldRefreshForTagInit) {
      sessionStorage.setItem(STORAGE_KEYS.cartRefreshedAfterTagInit, 'true');
    }
    if (shouldRefreshForTagChange) {
      sessionStorage.setItem(STORAGE_KEYS.lastCustomerTags, currentCustomerTags);
    }

    window.__CART_REFRESH_RUNNING__ = true;

    var showCartPending = isCartTemplatePage();
    if (showCartPending) setRecalcPending(true);

    try {
      await touchCartForRecalculation();
      await refreshPrestigeCartUI();
    } catch (innerErr) {
      if (showCartPending) setRecalcPending(false);
      throw innerErr;
    }

    window.__CART_REFRESH_RUNNING__ = false;
  } catch (error) {
    console.error('[custom-cart-refresh] error:', error);
    window.__CART_REFRESH_RUNNING__ = false;
    setRecalcPending(false);
    sessionStorage.removeItem(STORAGE_KEYS.cartRefreshedAfterLogin);
  }
})();